import React from 'react'
import GetSpotDetails from '../../components/Host/GetSpotDetails'

function SpotDetails() {
  return (
        <GetSpotDetails/>
  )
}

export default SpotDetails